import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburgerMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.66699 15.5128C1.38366 15.5128 1.14616 15.4169 0.954492 15.2252C0.762826 15.0334 0.666992 14.7958 0.666992 14.5124C0.666992 14.2289 0.762826 13.9914 0.954492 13.8C1.14616 13.6086 1.38366 13.5128 1.66699 13.5128H22.3336C22.6169 13.5128 22.8544 13.6087 23.0461 13.8005C23.2378 13.9922 23.3336 14.2298 23.3336 14.5133C23.3336 14.7967 23.2378 15.0342 23.0461 15.2256C22.8544 15.4171 22.6169 15.5128 22.3336 15.5128H1.66699ZM1.66699 8.99996C1.38366 8.99996 1.14616 8.9041 0.954492 8.71236C0.762826 8.52061 0.666992 8.28301 0.666992 7.99956C0.666992 7.7161 0.762826 7.47864 0.954492 7.2872C1.14616 7.09575 1.38366 7.00003 1.66699 7.00003H22.3336C22.6169 7.00003 22.8544 7.0959 23.0461 7.28763C23.2378 7.47939 23.3336 7.71699 23.3336 8.00043C23.3336 8.2839 23.2378 8.52135 23.0461 8.7128C22.8544 8.90424 22.6169 8.99996 22.3336 8.99996H1.66699ZM1.66699 2.48716C1.38366 2.48716 1.14616 2.39129 0.954492 2.19953C0.762826 2.0078 0.666992 1.7702 0.666992 1.48673C0.666992 1.20329 0.762826 0.965841 0.954492 0.774397C1.14616 0.58293 1.38366 0.487198 1.66699 0.487198H22.3336C22.6169 0.487198 22.8544 0.583075 23.0461 0.77483C23.2378 0.966586 23.3336 1.20419 23.3336 1.48763C23.3336 1.7711 23.2378 2.00855 23.0461 2.2C22.8544 2.39144 22.6169 2.48716 22.3336 2.48716H1.66699Z",
		fill: "#05668D"
	})]
});
const ForwardRef = forwardRef(SvgHamburgerMenu);
export { ForwardRef as ReactComponent };
